import '../MainFrame.css';
import "./ayuda.css"
import faqs from "../../../assets/iconos/ayuda/faqs.svg"



export default function Ayuda(props) {
  return (
    <div className='frame'>
      <div className="ayuda-options">
        <div className="ayuda-content" onClick={() => props.setActualFrame('faqs')}>
          <img src={faqs} alt="" className='ayuda-img' />
          <h4>Preguntas frecuentes</h4>
          <p>Consulta nuestra guía de soluciones a problemas frecuentes.</p>
        </div>
      </div>
    </div>
  );
}